import { useEffect, useRef, useState } from 'react'

type ScrollDirection = 'up' | 'down'

/*
 * Rolagens menores que isso nao trocam a direcao. Sem o limite, o ajuste
 * elastico do fim da pagina e o menor tremor do trackpad ficariam alternando
 * entre 'up' e 'down'.
 */
const THRESHOLD_IN_PIXELS = 4

/*
 * Direcao da ultima rolagem. Comeca em 'up' para que quem esconde conteudo na
 * descida comece visivel, com a pagina no topo.
 */
const useScrollDirection = () => {
  const [direction, setDirection] = useState<ScrollDirection>('up')
  const lastPosition = useRef(0)

  useEffect(() => {
    lastPosition.current = window.scrollY

    const handleScroll = () => {
      const position = window.scrollY
      const delta = position - lastPosition.current

      if (Math.abs(delta) < THRESHOLD_IN_PIXELS) return

      lastPosition.current = position
      setDirection(delta > 0 ? 'down' : 'up')
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return direction
}

export { useScrollDirection }
export type { ScrollDirection }
